module.exports = __webpack_public_path__ + "img/Temirlan-Satylhanov.0ebc5e16.jpg";